export const INIT_SUPER_ITEM = 'INIT_SUPER_ITEM'
export const INIT_SUPER_PERSIST_ITEM = 'INIT_SUPER_PERSIST_ITEM'
export const SET_SUPER_ITEM = 'SET_SUPER_ITEM'
export const SET_SUPER_PERSIST_ITEM = 'SET_SUPER_PERSIST_ITEM'
export const UNSET_SUPER_ITEM = 'UNSET_SUPER_ITEM'
